import { useTranslation } from 'react-i18next';
import Form from './form';
import Header from './header';
import { INotificationService, NotificationService } from '../services';
import Overlay from '../ui/overlay';
import {
  axiosMod,
  getGaClientId,
  getGaSessionId,
  getGaUserIdFromEmail,
  getPublicApiUrl,
  gtmEvent,
} from '../utility';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { IEnquiryOptionDto } from '../model';
import { EnquiryState, IEnquiryState } from './state';
import { Helmet } from 'react-helmet-async';
import LanguageSwitch from '../enquiry-sitaram/language-switch';
import Footer from '../enquiry-sitaram/footer';
import { ConsultationTeaser } from './consultation-teaser';

const notificationService: INotificationService = new NotificationService();
const enquiryState: IEnquiryState = new EnquiryState();

export function EnquiryPage() {
  const { t, i18n } = useTranslation();
  const q = useSearchParams();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const foundTreatment = searchParams.get('treatment');
  const foundRoom = searchParams.get('room');
  const foundCode = searchParams.get('code');

  let roomOptions: IEnquiryOptionDto[];

  let treatmentOptions: IEnquiryOptionDto[];

  if (foundTreatment) {
    treatmentOptions = [
      {
        name: foundTreatment,
        valueEnabled: true,
      },
    ];
  } else {
    treatmentOptions = [
      {
        name: t('treatment.snuff'), //Ayuveda Tasting
        valueEnabled: false,
      },
      {
        name: t('treatment.ayurveda'), //Pancha Karma
        valueEnabled: false,
      },
      {
        name: t('treatment.live'), //Detox
        valueEnabled: false,
      },
      {
        name: t('treatment.stress'), //Digital Detox - Burnout
        valueEnabled: false,
      },
      // {
      //   name: t('treatment.yoga'),
      //   valueEnabled: false,
      // },
    ];
  }

  if (foundRoom) {
    roomOptions = [
      {
        name: foundRoom,
        valueEnabled: true,
      },
    ];
  } else {
    roomOptions = [
      {
        name: t('room.big-suite'),
        valueEnabled: false,
      },
      {
        name: t('room.suite'),
        valueEnabled: false,
      },
      {
        name: t('room.normal'),
        valueEnabled: false,
      },
      {
        name: t('room.dog'),
        valueEnabled: false,
      },
    ];
  }

  const pricingOptions: IEnquiryOptionDto[] = [
    {
      name: t('pricing-option.low'),
      valueEnabled: false,
    },
    {
      name: t('pricing-option.medium'),
      valueEnabled: false,
    },
    {
      name: t('pricing-option.large'),
      valueEnabled: false,
    },
    {
      name: t('pricing-option.extralarge'),
      valueEnabled: false,
    },
    {
      name: t('pricing-option.huge'),
      valueEnabled: false,
    },
  ];

  //track on page mount/load
  useEffect(() => {
    gtmEvent('enquiry_start');
  }, []);

  return (
    <div>
      <Overlay service={notificationService}></Overlay>

      <Helmet htmlAttributes={{ lang: i18n.language }} />

      <Header actions={<LanguageSwitch></LanguageSwitch>}></Header>

      <div className="m-3 mb-10 space-y-3 text-brand-cashmere-900">
        <h1 className="text-3xl font-serif text-center">{t('header.title')}</h1>

        <p className="mt-2 text-center font-light max-w-lg mx-auto px-4">
          {t('header.subtitle')}
        </p>
      </div>

      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <Form
          enquiryState={enquiryState}
          roomOptions={roomOptions}
          code={foundCode}
          treatmentOptions={treatmentOptions}
          pricingOptions={pricingOptions}
          onSubmit={async (data) => {
            const userId = await getGaUserIdFromEmail(data.contactMail);
            const clientId = getGaClientId();
            const sessionId = getGaSessionId();

            if (q[0].get('test') === 'yes') {
              console.log('found test');
              console.log('client_id', clientId);
              console.log('user_id', userId);
              console.log('session_id', sessionId);
              console.log('data', data);

              gtmEvent('enquiry_finished', userId);

              return;
            }

            await axiosMod()
              .post(getPublicApiUrl('/enquiry'), {
                ...data,
                userId: userId,
                clientId: clientId,
                sessionId: sessionId,
                contactLanguage: i18n.language.toLowerCase(),
              })
              .then(() => {
                gtmEvent('enquiry_finished', userId);

                notificationService.createNotification({
                  type: 'success',
                  title: 'Vielen Dank für die Anfrage!',
                  description: 'Wir melden uns in kürze!',
                });
              })
              .finally(() => {
                navigate('finish');
              });
          }}
        ></Form>

        <ConsultationTeaser />
      </main>

      <Footer />
    </div>
  );
}

export default EnquiryPage;
